import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCompare } from '../context/CompareContext';
import { X, GitCompare, ArrowRight } from 'lucide-react';

export default function CompareTray() {
  const { list, remove, clear } = useCompare();
  const navigate = useNavigate();

  if (list.length === 0) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-[0_-8px_32px_rgba(0,0,0,0.12)] px-4 py-3"
      data-testid="compare-tray"
    >
      <div className="max-w-6xl mx-auto flex items-center gap-3 flex-wrap sm:flex-nowrap">
        <div className="flex items-center gap-1.5 flex-shrink-0">
          <GitCompare className="w-4 h-4 text-blue-700" />
          <span className="text-sm font-bold text-slate-900">Compare ({list.length}/3)</span>
        </div>

        <div className="flex items-center gap-2 flex-1 overflow-x-auto min-w-0">
          {list.map(p => (
            <div
              key={p.property_id}
              className="flex items-center gap-2 bg-slate-100 rounded-xl px-3 py-1.5 flex-shrink-0 max-w-[180px]"
              data-testid={`compare-tray-item-${p.property_id}`}
            >
              {p.images?.[0] && (
                <img src={p.images[0]} alt="" className="w-6 h-6 rounded-lg object-cover flex-shrink-0" />
              )}
              <span className="text-xs font-medium text-slate-700 truncate">{p.title || p.bhk_type}</span>
              <button
                onClick={() => remove(p.property_id)}
                className="flex-shrink-0 text-slate-400 hover:text-red-500 transition-colors"
                data-testid={`remove-compare-${p.property_id}`}
              >
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
          {Array.from({ length: 3 - list.length }).map((_, i) => (
            <div key={`empty-slot-${i}`} className="flex-shrink-0 w-32 h-8 border-2 border-dashed border-slate-200 rounded-xl flex items-center justify-center">
              <span className="text-xs text-slate-300">+ Add</span>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={clear}
            className="text-xs text-slate-500 hover:text-slate-700 transition-colors px-2 py-1.5"
            data-testid="clear-compare-btn"
          >
            Clear
          </button>
          <button
            disabled={list.length < 2}
            onClick={() => navigate('/compare')}
            className="flex items-center gap-1.5 bg-blue-700 hover:bg-blue-800 disabled:opacity-50 text-white text-sm font-bold px-4 py-2 rounded-xl transition-colors"
            data-testid="start-compare-btn"
          >
            Compare <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
